import { useEffect } from "react";
import { useSettings } from "./settings";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, noindex = false }) {
  const { settings } = useSettings();
  useEffect(() => {
    const company = (settings.company_name || "Arnav Enterprises").replace(/\s+/g, " ").trim();
    const fullTitle = title ? `${title} | ${company}` : `${company} | ${settings.tagline || "Solar Solutions in Akola"}`;
    const desc =
      description ||
      `${company} — solar panels, inverters, batteries and rooftop installations in Akola, Maharashtra. Get a free quote today.`;
    const url = window.location.origin + window.location.pathname;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", company);
    setMeta("name", "twitter:card", "summary_large_image");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, noindex, settings.company_name, settings.tagline]);
}
